import React from 'react';
// import Header from '../lib-ui/Header';
import { useState, useEffect } from 'react';
import { Stack, Box } from '@mui/material';
//import GlobalConfig Config from '../../../lib/Config';
import Config from '../Config';
import Strings from '../Strings';
import axios from 'axios';
import '../../../assets/style/fonts.css';
import '../../../assets/style/common.css';
//import bg_img from '../../assets/images/main_bg.jpg';
import Util from '../../../lib/Util';
//import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonIcon from '@mui/icons-material/Person';
import Button from '@mui/material/Button';
//import TopBar from '../common/TopBar';
//import MainTitle from '../../lib-ui/common/MainTitle';
// import ConfirmDialog from '../lib/ConfirmDialog';
import ConfirmDialog from '../../../lib-ui/common/ConfirmDialog'

// import TopBarWhite from '../../lib-ui/common/TopBarWhite';
import { object, string, number, date, InferType } from 'yup';
import { useForm, Controller, formState } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import UIString from '../../../assets/content/UIString';
import Footer from '../../../lib-ui/common/Footer';
import BusinessIcon from '@mui/icons-material/Business';
import MainHeader from '../MainHeader';
import MainFooter from '../MainFooter';
import '../../../assets/style/base.css';









export default () => {

    const [lang, setLang] = useState('ko');
    //const navigate = useNavigate();
    const [confirmDialogText, setConfirmDialogText] = useState('');
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showPW, setShowPW] = useState(false);

    const [brnFileName, setBrnFileName] = useState(null);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');


    useEffect(() => {
        //  setLang(Util.get_url_lang());
        const init = async () => {
            const ret = await Util.get(Config.API_URL + '/corp/auth/signup/countries');
            if (ret.result) {
                //alert(ret.data.length);
                setCountries(ret.data);
            } else {
                // alert(ret.result);
            }
        }

        init();

    }, []);

    function showConfirmAlert(text) {
        setConfirmDialogText(text);
        setShowConfirmDialog(true);
    }

    // Test

    // Define Yup schema
    const schema = Yup.object().shape({
        signup: Yup.object().shape({
            // corp_code: Yup.string().matches(/^([0-9a-zA-Z]{6,22})$/,UIString[lang].INVALID_CORP_CODE_FORMAT).required(UIString[lang].CORP_CODE_IS_REQUIRED),
            email: Yup.string().email(Strings.INVALID_EMAIL_FORMAT).required(Strings.EMAIL_IS_REQUIRED),
            password: Yup.string().min(6, Strings.INVALID_PASSWORD_FORMAT).max(40, Strings.INVALID_PASSWORD_FORMAT).required(Strings.PASSWORD_IS_REQUIRED),
        }),
    });

    // Use react-hook-form with Yup
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    // Handle form submission
    const onSubmit = (data) => {

        console.log('Form data:', data.signup.email + ' / ' + data.signup.password);


        axios.post('/ko/api/v1/corp/auth/signup', {
            name: data.signup.name,
            //corp_code: data.login.corp_code,
            email: data.signup.email,
            password: data.signup.password,
        })
            .then(response => {
                console.log('Success:', response.data);
                if (!response.data.result) {
                    showConfirmAlert(response.data.error);
                } else {
                    document.location.href = Config.BASE_URL + '/corp/dashboard';
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };
    //////////////////////////////////



    function goto_signup_form() {

        if( selectedCountry == '' ){
            alert(Strings.PLEASE_SELECT_COUNTRY_CORP_LOCATED);
            return;
        }

        document.location.href = Config.PAGE_BASE + '/corp/signup/'+selectedCountry;

    }






    const signup = (e) => {
        e.preventDefault();
        //alert('login');
    };

    // const { control, handleSubmit, errors } = useForm();

    return (
        <div style={{ width: '100%', height: '98vh', fontFamily: 'Roboto', fontSize: '13px', padding: '0x' }}>
            <table className={"base_table"} cellspacing={'0px'} cellpadding={'0px'}>
                <tr>
                    <td style={{ height: '48px' }}>
                        <MainHeader />
                    </td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'center', verticalAlign: 'top' }}>



                        <div style={{ width: '100%', margin: '0px auto', paddingTop: '110px', textAlign: 'center', backgroundColor: '#ffffff', fontFamily: 'Roboto' }}>
                            <div style={{ fontSize: '16px', margin: '0px auto' }}>{Strings.CORP_SIGNUP}</div>
                            <div style={{ height: '60px' }}></div>

                            <form method='POST' onSubmit={handleSubmit(onSubmit)} >

                                <div style={{ width: '320px', height: '22px', fontSize: '11px', color: '#222222', textAlign: 'left', margin: '0px auto' }}>{Strings.CORP_COUNTRY}</div>





                                <Controller
                                    //as={Input}
                                    name="signup.country"
                                    id="country"
                                    //label="First Name"

                                    control={control}
                                    // value={data.firstName}
                                    //rules={{ required: true }}
                                    //errors={errors.firstName}
                                    // onChange={([e]) => onChangeHandler(e)}
                                    render={({ field }) =>
                                        <FormControl
                                            error={!errors.signup?.country}
                                            helperText={errors.signup?.country ? errors.signup.country.message : ''}
                                            variant="outlined"
                                            style={{ marginBottom: '11px', }}
                                            sx={{
                                                m: 1, width: '320px', height: '42px',
                                                backgroundColor: '#ffffff',
                                                '& .MuiOutlinedInput-root': {
                                                    textAlign: 'left',
                                                    fontSize: '13px',
                                                    color: '#666666',
                                                    height: '43px',
                                                    backgroundColor: '#f8f8f8',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    '& fieldset': {
                                                        border: 'none',
                                                    },
                                                },

                                            }}
                                        >
                                            <Select
                                                labelId="demo-simple-select-filled-label"
                                                id="demo-simple-select-filled"
                                                value={selectedCountry}
                                                onChange={(t) => { setSelectedCountry(t.target.value) }}
                                            >
                                                {countries.map((item, index) => <MenuItem value={item.value} style={{ fontSize: '13px', textAlign: 'left', color: '#666666' }}>{item.label}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    }
                                />

                               
                                <div style={{width:'300px',margin:'0px auto',padding:'12px',fontSize:'12px',lineHeight:'20px',textAlign:'left'}}>
                                    {Strings.PLEASE_SELECT_COUNTRY_CORP_LOCATED}
                                </div>
                                <div style={{height:'200px'}}>&nbsp;&nbsp;</div>



















                                <br />

                                <br /><br />
                                <Button variant="text" type='submit' sx={{ height: '48px', color: Config.BUTTON_TEXT_COLOR, fontSize: '13px', marginTop: '180px', marginBottom: '200px', width: '320px', fontFamily: 'Roboto', fontWeight: 'normal', backgroundColor: Config.BUTTON_BG_COLOR }} onClick={()=>{ goto_signup_form() }}>{Strings.NEXT}</Button><br />
                                <br />
                                <br />

                            </form>


                        </div>



                    </td>
                </tr>
                <tr>
                    <td>
                        &nbsp;&nbsp;
                    </td>
                </tr>
                <tr>
                    <td style={{ height: '200px', textAlign: 'center' }}>
                        <MainFooter />
                        <ConfirmDialog show={showConfirmDialog} text={confirmDialogText} confirm_text={Strings.CONFIRM} handle_close={() => { setShowConfirmDialog(false); }} />
                    </td>
                </tr>
            </table>

        </div>
    );

}